export default __webpack_public_path__ + "static/banner-wedding-how-gen-y-are-doing-weddings-their-way-26b8b09a99b95c6867688b12f1b35c30.jpg";